import { omitKeys } from '@adsk/alloy-helpers';
export default (function (item1, item2) {
  // These keys are added by useGroupeditems and can change their value for the same object
  // so let's ignore them during this comparison
  var groupedItemKeys = ['groupKey', 'index'];
  return JSON.stringify(omitKeys(item1, groupedItemKeys)) === JSON.stringify(omitKeys(item2, groupedItemKeys));
});
//# sourceMappingURL=areItemsEqual.js.map